import { createContext, ReactNode, useContext, useEffect, useState } from 'react'

const UnsavedChangesContext = createContext<{
  setUnsavedChanges: (value: boolean) => void
  confirmLeave: () => boolean
} | null>(null)

export const UnsavedChangesProvider = ({ children }: { children: ReactNode }) => {
  const [dirty, setDirty] = useState(false)
  useEffect(() => {
    const warn = (event: BeforeUnloadEvent) => {
      if (!dirty) return
      event.preventDefault()
      event.returnValue = ''
    }
    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [dirty])

  return (
    <UnsavedChangesContext.Provider value={{
      setUnsavedChanges: setDirty,
      confirmLeave: () => !dirty || window.confirm('Discard unsaved company changes?'),
    }}>
      {children}
    </UnsavedChangesContext.Provider>
  )
}

export const useUnsavedChanges = () => {
  const context = useContext(UnsavedChangesContext)
  if (!context) throw new Error('useUnsavedChanges must be used inside the app layout')
  return context
}
